// Module
var code = "<h1 id=\"users\">Users</h1> <p>EMPTY</p> ";
// Exports
module.exports = code;